import React from 'react';
import {Badge, Button, Col, Row} from "reactstrap";
import {getStats} from "../../components/helpers/StatsHelpers";
import {RiBookLine, RiBookOpenFill, RiBookOpenLine, RiCloudy2Line, RiSpeakFill, RiSpeakLine} from "react-icons/ri";
import {RiBookShelfLine} from "@remixicon/react";

class StatsOverviewWithSongBook extends React.Component {
    state = {
        stats: [],
        chosenSongBooksButtons: null,
    }

    constructor(props) {
        super(props);
        getStats.call(this);
    }

    render() {
        return (
            <div>
                <div className="col-md-12 col-xs-12 card-profile-stats d-flex justify-content-center row">
                    <div className="col-md-3 col-xs-12 flex-wrap">
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : <RiBookOpenLine color="#5e72e4"/>}</span>
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books")?.title + ":"}</span>
                        <span className="stats-description">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Song Books")?.value}</span>
                    </div>
                    <div className="col-md-3 col-xs-12 flex-wrap">
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : <RiSpeakLine color="#5e72e4"/>}</span>
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Songs")?.title + ":"}</span>
                        <span className="stats-description">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Songs")?.value}</span>
                    </div>
                    <div className="col-md-3 col-xs-12 flex-wrap">
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : <RiCloudy2Line color="#5e72e4"/>}</span>
                        <span className="stats-heading">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Themes")?.title + ":"}</span>
                        <span className="stats-description">{!sessionStorage.getItem("statsTtl") ? "" : JSON.parse(sessionStorage.getItem("statsTtl")).stats.find(x => x.title === "Themes")?.value}</span>
                    </div>
                </div>
            </div>
        )
    }
};

export default StatsOverviewWithSongBook;
